namespace GeniuzPOS.Inventory {
    export enum PostFgStatus {
        UnPost = 0,
        Posted = 1,
        inpro = 2,
        inprotrigger = 3
    }
    Serenity.Decorators.registerEnumType(PostFgStatus, 'GeniuzPOS.Inventory.PostFgStatus');
}
